import React from 'react'
import PrimaryFieldsSection from './PrimaryFieldsSection'

const Individual = (props: any) => {
  return (
    <>
      <div className="py-4 text-left text-2xl font-semibold text-gray-900 md:py-12 md:pb-10 md:text-4xl">
        A few details about yourself...
      </div>

      <PrimaryFieldsSection {...props} />
    </>
  )
}

export default Individual
